<!-- <IFA-header></IFA-header> -->

<main id="primary" class="site-main customMain">
  <section class="relative">
    <div class="container px-4 pt-5 mt-120">
      <div class="content-panelMobile">
        <div class="row d-flex">
          <div class="col-12">
            <div class="sb-tag sb-offerings mb-12">MUTUAL FUNDS</div>
            <h2 class="wealth-section-title mb-6">
              Advantages of Mutual Funds Investments
            </h2>
            <p class="wealth-section-description">
              Know the benefits and start your wealth journey.
            </p>
          </div>
        </div>

        <div
          class="lg:w-full lg:max-w-full post-content pb-4 pt-8 lg:pt-6 sm:pt-4">
          <div class="wp-block-columns sec-ques-ans">
            <div class="wp-block-column" style="flex-basis: 30%">
              <div class="sidebar-block sticky pt-16">
                <div
                  id="lpwtoc_widget-3"
                  class="widget widget-sidebar widget_lpwtoc_widget">
                  <!--noindex-->
                  <div
                    class="lwptoc lwptoc-autoWidth lwptoc-inherit"
                    data-smooth-scroll="1"
                    data-smooth-scroll-offset="60"
                    data-lwptoc-initialized="1">
                    <div class="lwptoc_i">
                      <div class="lwptoc_header">
                        <b class="lwptoc_title bold UpperCase">
                          Advantages of Investing
                        </b>
                      </div>
                      <div
                        class="lwptoc_items1 lwptoc_items-visible"
                        style="font-size: 12pt">
                        <ol class="lwptoc_itemWrap">
                          <li class="lwptoc_item active">
                            <a href="#Tab1" data-toggle="tab" rel="nofollow">
                              <span class="lwptoc_item_label">
                                Professional Management
                              </span>
                            </a>
                          </li>

                          <li class="lwptoc_item">
                            <a href="#Tab2" rel="nofollow">
                              <span class="lwptoc_item_label">
                                Risk Diversification
                              </span>
                            </a>
                          </li>
                          <li class="lwptoc_item">
                            <a href="#Tab3" rel="nofollow">
                              <span class="lwptoc_item_label">
                                Affordability & Convenience (Invest Small
                                Amounts)
                              </span>
                            </a>
                          </li>
                          <li class="lwptoc_item">
                            <a href="#Tab4" rel="nofollow">
                              <span class="lwptoc_item_label">Liquidity</span>
                            </a>
                          </li>
                          <li class="lwptoc_item">
                            <a href="#Tab5" rel="nofollow">
                              <span class="lwptoc_item_label">Low Cost</span>
                            </a>
                          </li>

                          <li class="lwptoc_item">
                            <a href="#Tab6" rel="nofollow">
                              <span class="lwptoc_item_label">
                                Tax Benefits
                              </span>
                            </a>
                          </li>
                        </ol>
                      </div>
                    </div>
                  </div>
                  <!--/noindex-->
                </div>
              </div>
            </div>
            <!-- <div class="wp-block-column mt-120" style="flex-basis:70%">
              <div id="StandardRisk" class="HeadingTitle">
                <h2 class="is-style-fancy-heading">
                  <a class="acc-title" data-toggle="collapse" data-parent="#ques_ans_accordian"
                    href="#HowtousetheETMONEYMutualFundReturnsCalculator_ans" aria-expanded="false"
                    aria-controls="what_is_fd_calci_ans">
                    Professional Management <i class="arrow-down"></i></a>

                </h2>
                <p>

                  Investors may not have the time or the required knowledge and resources to conduct their research and
                  purchase individual stocks or bonds. A mutual fund is managed by full-time, professional money
                  managers
                  who
                  have the expertise, experience and resources to actively buy, sell, and monitor investments. A fund
                  manager
                  continuously monitors investments and rebalances the portfolio accordingly to meet the scheme’s
                  objectives.
                  Portfolio management by professional fund managers is one of the most important advantages of a mutual
                  fund.

                </p>
              </div>
              <div id="Riskoflosingmoney" class="HeadingTitle">
                <h2 class="is-style-fancy-heading">
                  Risk Diversification
                </h2>
                <p>

                  Buying shares in a mutual fund is an easy way to diversify your investments across many securities and
                  asset
                  categories such as equity, debt and gold, which helps in spreading the risk - so you won't have all
                  your
                  eggs in one basket. This proves to be beneficial when an underlying security of a given mutual fund
                  scheme
                  experiences market headwinds. With diversification, the risk associated with one asset class is
                  countered by
                  the others. Even if one investment in the portfolio decreases in value, other investments may not be
                  impacted and may even increase in value. In other words, you don’t lose out on the entire value of
                  your
                  investment if a particular component of your portfolio goes through a turbulent period. Thus, risk
                  diversification is one of the most prominent advantages of investing in mutual funds.

                </p>
              </div>
              <div id="PriceRisk" class="HeadingTitle">
                <h2 class="is-style-fancy-heading">
                  Affordability & Convenience (Invest Small Amounts)
                </h2>
                <div>

                  For many investors, it could be more costly to directly purchase all of the individual securities held
                  by a
                  single mutual fund. By contrast, the minimum initial investments for most mutual funds are more
                  affordable.

                  <h2><span id="PriceRisk1">Thematic funds</span></h2>
                  <div>
                    <ul>
                      <li> Thematic funds select stocks of companies in industries that belong to a particular theme -
                        For
                        example, Infrastructure, Service industries, PSUs or MNCs. </li>
                      <li> They are more diversified than Sectoral Funds and hence have lower risk than Sectoral funds.
                      </li>
                    </ul>

                  </div>

                </div>
              </div>

              <div id="LiquidityRisk" class="HeadingTitle">
                <h2 class="is-style-fancy-heading">
                  Liquidity
                </h2>
                <div>

                  You can easily redeem (liquidate) units of open ended mutual fund schemes to meet your financial needs
                  on
                  any business day (when the stock markets and/or banks are open), so you have easy access to your
                  money.
                  Upon
                  redemption, the redemption amount is credited in your bank account within one day to 3-4 days,
                  depending
                  upon the type of scheme e.g., in respect of Liquid Funds and Overnight Funds, the redemption amount is
                  paid
                  out the next business day.

                  However, please note that units of close-ended mutual fund schemes can be redeemed only on maturity.
                  Likewise, units of ELSS have a 3-year lock-in period and can be liquidated only thereafter.

                </div>
              </div>
              <div id="EventRisk" class="HeadingTitle">
                <h2 class="is-style-fancy-heading">
                  Low Cost
                </h2>
                <div>

                  An important advantage of mutual funds is their low cost. Due to huge economies of scale, mutual funds
                  schemes have a low expense ratio. Expense ratio represents the annual fund operating expenses of a
                  scheme,
                  expressed as a percentage of the fund’s daily net assets. Operating expenses of a scheme are
                  administration,
                  management, advertising related expenses, etc. The limits of expense ratio for various types of
                  schemes
                  has
                  been specified under Regulation 52 of SEBI Mutual Fund Regulations, 1996.

                </div>
              </div>


              <div id="InterestRateRisk" class="HeadingTitle">
                <h2 class="is-style-fancy-heading">

                  Tax Benefits
                </h2>
                <div>

                  Investment in ELSS upto ₹1,50,000 qualifies for tax benefit under section 80C of the Income Tax Act,
                  1961.
                  Mutual Fund investments when held for a longer term are tax efficient.

                </div>
              </div>


            </div> -->

            <div class="wp-block-column mt-120" style="flex-basis: 70%">
              <div
                class="answer-contents calculator_accordian desktop-disabled-acc"
                id="ques_ans_accordian">
                <div class="what-is-hra ans-card" id="Tab1">
                  <h2 class="is-style-fancy-heading">
                    <a
                      class="acc-title"
                      data-toggle="collapse"
                      data-parent="#ques_ans_accordian"
                      href="#Tab1_ans"
                      aria-expanded="false"
                      aria-controls="what_is_fd_calci_ans">
                      Professional Management
                      <i class="arrow-down"></i></a>
                  </h2>
                  <div class="collapse" id="Tab1_ans">
                    <div class="main-panel">
                      <p>
                        Investors may not have the time or the required
                        knowledge and resources to conduct their research and
                        purchase individual stocks or bonds. A mutual fund is
                        managed by full-time, professional money managers who
                        have the expertise, experience and resources to actively
                        buy, sell, and monitor investments. A fund manager
                        continuously monitors investments and rebalances the
                        portfolio accordingly to meet the scheme’s objectives.
                        Portfolio management by professional fund managers is
                        one of the most important advantages of a mutual fund.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="what-is-hra ans-card" id="Tab2">
                  <h2 class="is-style-fancy-heading">
                    <a
                      class="acc-title"
                      data-toggle="collapse"
                      data-parent="#ques_ans_accordian"
                      href="#Tab2_ans"
                      aria-expanded="false"
                      aria-controls="what_is_fd_calci_ans">
                      Risk Diversification
                      <i class="arrow-down"></i></a>
                  </h2>
                  <div class="collapse" id="Tab2_ans">
                    <div class="main-panel">
                      <p>
                        Buying shares in a mutual fund is an easy way to
                        diversify your investments across many securities and
                        asset categories such as equity, debt and gold, which
                        helps in spreading the risk - so you won't have all your
                        eggs in one basket. This proves to be beneficial when an
                        underlying security of a given mutual fund scheme
                        experiences market headwinds. With diversification, the
                        risk associated with one asset class is countered by the
                        others. Even if one investment in the portfolio
                        decreases in value, other investments may not be
                        impacted and may even increase in value. In other words,
                        you don’t lose out on the entire value of your
                        investment if a particular component of your portfolio
                        goes through a turbulent period. Thus, risk
                        diversification is one of the most prominent advantages
                        of investing in mutual funds.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="what-is-hra ans-card" id="Tab3">
                  <h2 class="is-style-fancy-heading">
                    <a
                      class="acc-title"
                      data-toggle="collapse"
                      data-parent="#ques_ans_accordian"
                      href="#Tab3_ans"
                      aria-expanded="false"
                      aria-controls="what_is_fd_calci_ans">
                      Affordability & Convenience (Invest Small Amounts)
                      <i class="arrow-down"></i></a>
                  </h2>
                  <div class="collapse" id="Tab3_ans">
                    <div class="main-panel">
                      <div>
                        <p>
                          For many investors, it could be more costly to
                          directly purchase all of the individual securities
                          held by a single mutual fund. By contrast, the minimum
                          initial investments for most mutual funds are more
                          affordable.
                        </p>
                        <h2><span id="PriceRisk1">Thematic funds</span></h2>
                        <div>
                          <ul>
                            <li>
                              Thematic funds select stocks of companies in
                              industries that belong to a particular theme - For
                              example, Infrastructure, Service industries, PSUs
                              or MNCs.
                            </li>
                            <li>
                              They are more diversified than Sectoral Funds and
                              hence have lower risk than Sectoral funds.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="what-is-hra ans-card" id="Tab4">
                  <h2 class="is-style-fancy-heading">
                    <a
                      class="acc-title"
                      data-toggle="collapse"
                      data-parent="#ques_ans_accordian"
                      href="#Tab4_ans"
                      aria-expanded="false"
                      aria-controls="what_is_fd_calci_ans">
                      Liquidity
                      <i class="arrow-down"></i></a>
                  </h2>
                  <div class="collapse" id="Tab4_ans">
                    <div class="main-panel">
                      <p>
                        You can easily redeem (liquidate) units of open ended
                        mutual fund schemes to meet your financial needs on any
                        business day (when the stock markets and/or banks are
                        open), so you have easy access to your money. Upon
                        redemption, the redemption amount is credited in your
                        bank account within one day to 3-4 days, depending upon
                        the type of scheme e.g., in respect of Liquid Funds and
                        Overnight Funds, the redemption amount is paid out the
                        next business day. However, please note that units of
                        close-ended mutual fund schemes can be redeemed only on
                        maturity. Likewise, units of ELSS have a 3-year lock-in
                        period and can be liquidated only thereafter.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="what-is-hra ans-card" id="Tab5">
                  <h2 class="is-style-fancy-heading">
                    <a
                      class="acc-title"
                      data-toggle="collapse"
                      data-parent="#ques_ans_accordian"
                      href="#Tab5_ans"
                      aria-expanded="false"
                      aria-controls="what_is_fd_calci_ans">
                      Low Cost
                      <i class="arrow-down"></i></a>
                  </h2>
                  <div class="collapse" id="Tab5_ans">
                    <div class="main-panel">
                      <p>
                        An important advantage of mutual funds is their low
                        cost. Due to huge economies of scale, mutual funds
                        schemes have a low expense ratio. Expense ratio
                        represents the annual fund operating expenses of a
                        scheme, expressed as a percentage of the fund’s daily
                        net assets. Operating expenses of a scheme are
                        administration, management, advertising related
                        expenses, etc. The limits of expense ratio for various
                        types of schemes has been specified under Regulation 52
                        of SEBI Mutual Fund Regulations, 1996.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="what-is-hra ans-card" id="Tab6">
                  <h2 class="is-style-fancy-heading">
                    <a
                      class="acc-title"
                      data-toggle="collapse"
                      data-parent="#ques_ans_accordian"
                      href="#Tab6_ans"
                      aria-expanded="false"
                      aria-controls="what_is_fd_calci_ans">
                      Tax Benefits
                      <i class="arrow-down"></i></a>
                  </h2>
                  <div class="collapse" id="Tab6_ans">
                    <div class="main-panel">
                      <p>
                        Investment in ELSS upto ₹1,50,000 qualifies for tax
                        benefit under section 80C of the Income Tax Act, 1961.
                        Mutual Fund investments when held for a longer term are
                        tax efficient.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="grid-layout-common">
    <div class="container">
      <div class="col-md-12 col-xs-12 col-sm-12 nopadding">
        <div class="product-card-grid hover-animation" data-grid-size="8">
          <a
            id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3"
            class="card"
            href="mf/Mutual-Fund"
            target="_self">
            <span>
              Mutual Funds -
              <br />
              <span class="no-wrap-text">Introduction & More</span>
            </span>
            <span class="icon fa fa-angle-right"></span>
          </a>
          <a
            id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3"
            class="card"
            href="mf/Types_Of_MF"
            target="_self">
            <span>
              Various types
              <br />
              <span class="no-wrap-text">of Mutual Funds</span>
            </span>
            <span class="icon fa fa-angle-right"></span>
          </a>
          <a
            id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3"
            class="card"
            href="mf/SIP"
            target="_self">
            <span>
              Systematic
              <br />
              <span class="no-wrap-text">Investment Plan?</span>
            </span>
            <span class="icon fa fa-angle-right"></span>
          </a>
          <a
            id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3"
            class="card active"
            href="mf/Advantages_Of_MutualFundsComponent"
            target="_self">
            <span>
              Advantages of
              <br />
              <span class="no-wrap-text">Mutual Funds</span>
            </span>
            <span class="icon fa fa-angle-right"></span>
          </a>
          <a
            id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3"
            class="card"
            href="mf/categorization-of-mutual-funds"
            target="_self">
            <span>
              Categorisation of
              <br />
              <span class="no-wrap-text">Mutual Funds</span>
            </span>
            <span class="icon fa fa-angle-right"></span>
          </a>
          <a
            id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3"
            class="card"
            href="mf/risks-in-mutual-funds"
            target="_self">
            <span>
              Risk Factors in
              <br />
              <span class="no-wrap-text">Mutual Funds</span>
            </span>
            <span class="icon fa fa-angle-right"></span>
          </a>
          <a
            id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3"
            class="card"
            href="mf/FAQ#Myth"
            target="_self">
            <span>
              Myths & Facts
              <br />
              <span class="no-wrap-text">about Mutual Funds</span>
            </span>
            <span class="icon fa fa-angle-right"></span>
          </a>
          <a
            id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3"
            class="card"
            href="mf/FAQ#FAQ"
            target="_self">
            <span>
              What is NAV?
              <br />
              <span class="no-wrap-text">& Other FAQs</span>
            </span>
            <span class="icon fa fa-angle-right"></span>
          </a>
          <a
            id="id-ebe318f3-49dd-4b4f-9c3a-0cb8514a69fd"
            class="card link-plain featured customCard"
            (click)="modalPopOpen()"
            target="_self">
            <p
              style="
                font-size: 19px;
                color: #000;
                font-weight: bold;
                margin-bottom: 0px;
              ">
              Schedule a Call back
            </p>
          </a>
        </div>
      </div>
    </div>
  </section>
  <!-- lets talk of model -->

  <div
    aria-hidden="true"
    aria-labelledby="LetsTalk_popup"
    class="modal fade"
    data-keyboard="false"
    id="LetsTalk_popup"
    tabindex="-1">
    <div class="modal-dialog modal-dialog-centered border-0">
      <div class="modal-content border-0 p-0">
        <div class="modal-header border-0 p-0 ltmodalheader">
          <button
            aria-label="Close"
            class="close"
            data-dismiss="modal"
            type="button">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body border-0 p-10 pt-0 mobilep-2">
          <form>
            <div
              class="col-sm-12 col-md-12 col-xs-12 schedule-a-call-container">
              <div class="align-self-center">
                <h2
                  class="wealth-section-title mb-8 mobilemb-5 mobilemt-0 fcwelth">
                  Let's Talk
                </h2>

                <p
                  class="wealth-section-description mb-12 mt-10 mobilemt-0 mobilemb-10">
                  Let's connect on a quick call to understand better.
                </p>
              </div>

              <div class="row">
                <div class="col-sm-12 col-md-12 col-xs-12 mt-10 mobilemt-0">
                  <div class="call-plan-form-group call-plan-form-group-name">
                    <input
                      class="form-control"
                      id="customer_name"
                      maxlength="30"
                      placeholder="Full Name"
                      name="customer-name"
                      required=""
                      type="text" />
                    <label for="customer-name"></label>
                    <span class="d-none customer-name-error" style="color: red">
                      Please enter your name
                    </span>
                  </div>
                </div>
                <!-- <div class="col-sm-6 col-md-6 col-xs-6 MobileHide">
                    <div class="call-plan-form-group call-plan-form-group-name">

                      <input class="form-control" id="customer_name" placeholder="last name"
                        maxlength="30" name="customer-name" required="" type="text">
                      <label for="customer-name"></label>
                      <span class="d-none customer-name-error" style="color: red">
                        Please enter your name
                      </span>
                    </div>
                  </div> -->
              </div>
              <div class="row">
                <div class="col-sm-6 col-md-6 col-xs-6">
                  <div class="call-plan-form-group call-plan-form-group-name">
                    <input
                      class="form-control"
                      id="customer_name"
                      maxlength="30"
                      placeholder="Mobile"
                      name="customer-name"
                      required=""
                      type="text" />
                    <label for="customer-name"></label>
                    <span class="d-none customer-name-error" style="color: red">
                      Please enter your name
                    </span>
                  </div>
                </div>
                <div class="col-sm-6 col-md-6 col-xs-6">
                  <div class="call-plan-form-group call-plan-form-group-name">
                    <input
                      class="form-control"
                      id="customer_name"
                      placeholder="Email"
                      maxlength="30"
                      name="customer-name"
                      required=""
                      type="text" />
                    <label for="customer-name"></label>
                    <span class="d-none customer-name-error" style="color: red">
                      Please enter your name
                    </span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6 col-md-6 col-xs-6">
                  <div class="call-plan-form-group call-plan-form-group-name">
                    <!-- <select class="form-control">
                      <option>State</option>
                    </select> -->
                    <input
                      class="form-control"
                      id="Statein"
                      placeholder="State"
                      maxlength="30"
                      name="Statein"
                      required=""
                      type="text" />
                    <label for="Statein"></label>
                    <span class="d-none Statein-error" style="color: red">
                      Please enter state
                    </span>
                  </div>
                </div>
                <div class="col-sm-6 col-md-6 col-xs-6">
                  <div class="call-plan-form-group call-plan-form-group-name">
                    <input
                      class="form-control"
                      id="customer_name"
                      maxlength="30"
                      placeholder="City"
                      name="customer-name"
                      required=""
                      type="text" />
                    <label for="customer-name"></label>
                    <span class="d-none customer-name-error" style="color: red">
                      Please enter your name
                    </span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-12 col-xs-6">
                  <div class="call-plan-form-group call-plan-form-group-name">
                    <input
                      class="form-control"
                      id="customer_name"
                      maxlength="30"
                      placeholder="Message"
                      name="customer-name"
                      required=""
                      type="text" />
                    <label for="customer-name"></label>
                    <span class="d-none customer-name-error" style="color: red">
                      Please enter your name
                    </span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 col-sm-12 col-xs-12">
                  <div class="call-plan-form-group">
                    <label class="form-label">Preferred time to talk:</label>
                  </div>
                  <div
                    class="btn-group btn-group-toggle select-call-time select-call-time-js"
                    data-toggle="buttons">
                    <label class="btn btn-outline-sb-green option-1 active">
                      <input
                        data-max="12"
                        data-min="8"
                        id="option1"
                        name="schedule_time"
                        type="radio"
                        value="morning" />

                      10 - 12
                    </label>
                    <label class="btn btn-outline-sb-green option-2">
                      <input
                        data-max="16"
                        data-min="12"
                        id="option2"
                        name="schedule_time"
                        type="radio"
                        value="afternoon" />

                      12 - 2
                    </label>
                    <label class="btn btn-outline-sb-green option-3">
                      <input
                        data-max="20"
                        data-min="16"
                        id="option3"
                        name="schedule_time"
                        type="radio"
                        value="evening" />

                      2 - 4
                    </label>
                    <label class="btn btn-outline-sb-green option-3">
                      <input
                        data-max="20"
                        data-min="16"
                        id="option3"
                        name="schedule_time"
                        type="radio"
                        value="evening" />

                      4 - 6
                    </label>
                    <label class="btn btn-outline-sb-green option-3">
                      <input
                        data-max="20"
                        data-min="16"
                        id="option3"
                        name="schedule_time"
                        type="radio"
                        value="evening" />

                      6 - 8
                    </label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 mb-20">
                  <div
                    class="call-plan-form-group text-center mt-30 mobilemt-0 mobilemb-0">
                    <div
                      class="mt-3 sb-primary-cta-button large-btn schedule-a-call trigger-event schedule-a-call-js"
                      data-action="schedule a call-Plan"
                      data-category="offering-Plan"
                      data-label="planning section">
                      Call Me
                    </div>
                    <a
                      href="mf/MobileMutualFund"
                      style="font-size: 10px"
                      target="_self"
                      class="anchorColor desktopHide">
                      Click here to know more about Mutual Funds first
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <!-- end-->
</main>

<IFA-footer></IFA-footer>
